import {initializeTemplateFields} from '../TemplateFields';
import {refreshActionPreview} from './Preview/Synchronizer';

const keyRequests = new WeakMap();

const valueRequests = new WeakMap();

const keyContainer = (group) => {
    const keySelect = group.querySelector('[name="key"]');

    return keySelect?.closest('.select-container') ?? keySelect;
};

export const cascadeIntegrationFieldKeyOptions = async (event) => {
    const group = event.target.closest('.automation-action .attached-select[data-cascade-url]');

    if (!group || !event.target.closest('[name="integration"]')) {
        return;
    }

    const current = keyContainer(group);

    if (!current) {
        return;
    }

    const url = new URL(group.dataset.cascadeUrl, window.location.origin);
    url.searchParams.set('integration', group.querySelector('[name="integration"]').value ?? '');

    keyRequests.get(group)?.abort();

    const controller = new AbortController();
    keyRequests.set(group, controller);

    try {
        const response = await fetch(url.toString(), {signal: controller.signal});

        if (!response.ok) {
            return;
        }

        const parsed = document.createElement('template');
        parsed.innerHTML = await response.text();

        current.replaceWith(parsed.content);
    } catch {
        // Aborted by a newer request for this group.
    }
};

const cascadeRoot = (action) => action.querySelector('[data-value-cascade-url]');

const swapInto = (target, source) => {
    if (!target || !source) {
        return;
    }

    target.replaceChildren(...source.childNodes);
};

export const cascadeIntegrationFieldValueField = async (event) => {
    const action = event.target.closest('.automation-action');

    if (!action || !event.target.closest('[name="integration"], [name="key"]')) {
        return;
    }

    const root = cascadeRoot(action);

    if (!root) {
        return;
    }

    const url = new URL(root.dataset.valueCascadeUrl, window.location.origin);
    url.searchParams.set('integration', action.querySelector('[name="integration"]')?.value ?? '');

    const keyChangedItself = event.target.closest('[name="key"]') !== null;

    url.searchParams.set('key', keyChangedItself ? action.querySelector('[name="key"]')?.value ?? '' : '');

    valueRequests.get(root)?.abort();

    const controller = new AbortController();
    valueRequests.set(root, controller);

    try {
        const response = await fetch(url.toString(), {signal: controller.signal});

        if (!response.ok) {
            return;
        }

        const parsed = document.createElement('template');
        parsed.innerHTML = await response.text();

        const parameters = action.querySelector('[data-key-parameter]');
        const parsedParameters = parsed.content.querySelector('[data-key-parameter]');
        const value = action.querySelector('.integration-field-value-cascade');

        swapInto(parameters, parsedParameters);
        swapInto(value, parsed.content.querySelector('[data-value-field]'));

        if (parameters && parsedParameters) {
            parameters.dataset.labelTemplate = parsedParameters.dataset.labelTemplate;
        }

        if (value) {
            initializeTemplateFields(value);
        }

        refreshActionPreview(action);
    } catch {
        // Aborted by a newer request for this action.
    }
};

document.addEventListener('change', cascadeIntegrationFieldKeyOptions);
document.addEventListener('change', cascadeIntegrationFieldValueField);
